import { useMutation, useQuery } from '@tanstack/react-query'
import { apiClient } from '../../lib/api'
import { REVIEWS_ENDPOINTS } from './reviews.endpoints'
import type { PendingReview, WriteReviewRequest } from './reviews.types'

export const usePendingReviewsQuery = () => {
  return useQuery({
    queryKey: ['pendingReviews'],
    queryFn: async () => {
      const { data } = await apiClient.get<PendingReview[]>(REVIEWS_ENDPOINTS.PENDING_REVIEWS)
      return data
    },
  })
}

export const useSubmitReviewMutation = () => {
  return useMutation({
    mutationFn: async (payload: WriteReviewRequest) => {
      const { data } = await apiClient.post(REVIEWS_ENDPOINTS.SUBMIT_REVIEW, payload)
      return data
    },
  })
}
